























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class MandalaLagDisplayComponent extends Vue {
  @Prop({ type: String, required: true })
  name !: string;

  @Prop({ type: Number, default: 0 })
  lag !: number;
}
